var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMaskSad = function SvgIconMaskSad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.693 10.584a1 1 0 0 0-1.492 1.332 3.25 3.25 0 0 0 4.848 0 1 1 0 1 0-1.491-1.332 1.25 1.25 0 0 1-1.865 0M14.443 10.584a1 1 0 0 0-1.492 1.332 3.25 3.25 0 0 0 4.848 0 1 1 0 1 0-1.491-1.332 1.25 1.25 0 0 1-1.865 0M8.962 16.417a5.49 5.49 0 0 1 6.076 0 1 1 0 1 1-1.107 1.666 3.49 3.49 0 0 0-3.862 0 1 1 0 1 1-1.107-1.666"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4.25c-2.905 0-5.498-.823-6.861-1.346A1.74 1.74 0 0 0 2.75 4.533V9.75c0 3.49.97 6.694 2.592 9.052C6.961 21.156 9.298 22.75 12 22.75s5.04-1.594 6.658-3.948c1.621-2.358 2.592-5.562 2.592-9.052V4.533a1.74 1.74 0 0 0-2.389-1.629C17.498 3.427 14.905 4.25 12 4.25m0 2c-3.025 0-5.705-.79-7.25-1.356V9.75c0 3.138.876 5.934 2.24 7.919 1.368 1.989 3.156 3.08 5.01 3.08s3.642-1.091 5.01-3.08c1.364-1.985 2.24-4.781 2.24-7.92V4.895C17.705 5.459 15.025 6.25 12 6.25",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMaskSad;